import React from "react";
import { PaymentDistribution } from "us.collection.transactions/components";

interface ICnt_PaymentDistributionProps {
  caseNo: number;
  [key: string]: any;
}

const Cnt_PaymentDistribution: React.FC<ICnt_PaymentDistributionProps> = (
  props
) => {

  return (
    <>
      <PaymentDistribution />
    </>
  );
};

export default Cnt_PaymentDistribution;
